<template>
  <!-- Start support devices -->
  <van-space
    v-if="showSupportedDevices"
    class="d-flex justify-content-end align-items-center w-100 gap-2 mb-2"
  >
    <div
      @click="handleShowCheckEsim"
      class="d-flex justyfy-content-center align-items-center gap-2"
    >
      <p class="txt-link">{{ $t("esim_supported_devices") }}</p>
      <van-icon name="question" color="#005D85" size="16" />
    </div>
  </van-space>
  <!-- End support devices -->
  <!-- Start Search -->
  <div class="custom-card filter py-4 mb-3">
    <p class="font-size-12">{{ $t("esim_enter_number") }}</p>
    <van-form @submit="onSubmit">
      <div class="d-flex align-items-center mb-3 gap-2">
        <!-- <van-field v-model="search" name="search" :placeholder="$t('esim_number_input')" class="form-control" /> -->
        <van-field
          v-model="search"
          name="search"
          type="tel"
          inputmode="numeric"
          maxlength="15"
          :placeholder="$t('esim_number_input')"
          class="form-control cs-input"
        />
        <van-button
          block
          class="btn btn-primary cs-btn-search"
          native-type="submit"
          @click="handleSearch"
        >
          {{ $t("esim_search") }}
        </van-button>
      </div>
      <div class="mb-3">
        <p class="font-size-12 mb-0 fst-italic" style="color: #545456">
          <i18n-t keypath="esim_search_phone_number_instruction">
            <template #search>
              <strong>"{{ $t("esim_search") }}"</strong>
            </template>
          </i18n-t>
        </p>
      </div>
      <div class="mb-2">
        <p class="mb-4 font-size-12">
          {{ $t("esim_choose_price_range") }}:<span class="text-green">
            ${{ this.priceRange[0] }}</span
          >
          {{ $t("esim_to") }}
          <span class="text-green">${{ this.priceRange[1] }}</span>
        </p>
        <!-- <van-slider v-model="priceRange" :min="minRange" :max="maxRange" range @change="onChangePrice"
          active-color="#3C3E3F" /> -->
        <div class="px-3">
          <van-slider
            v-model="priceRange"
            range
            :min="1"
            :max="1000"
            @change="onSliderInput"
            active-color="#3C3E3F"
          >
            <template #left-button="{ dragging }">
              <div
                class="custom-thumb"
                :class="{ dragging }"
                @mousedown.stop
              ></div>
            </template>
            <template #right-button="{ dragging }">
              <div
                class="custom-thumb"
                :class="{ dragging }"
                @mousedown.stop
              ></div>
            </template>
          </van-slider>
        </div>
      </div>
      <!-- <p class="font-size-12 mb-0 fst-italic" style="color: #545456">{{ $t('esim_search_phone_number_instruction') }}
      </p> -->
    </van-form>
  </div>
  <!-- <div class="mb-3">
    <van-button block class="btn btn-primary mb-3" native-type="submit" @click="handleSearch">
      {{ $t('esim_search') }}
    </van-button>
    <van-button block class="btn btn-primary" native-type="submit" @click="handleMyOrder">
      {{ $t('esim_my_ordered') }}
    </van-button>
  </div> -->
  <!-- End Search -->

  <!-- Start Isdn -->
  <div class="mb-3">
    <div class="d-flex justify-content-between align-items-end">
      <!-- <p class="m-0"
        v-if="(isShowIsdnRecommend && recommendedIsdns.length > 0) || (!isShowIsdnRecommend && displayIsdn.length > 0)">
        {{
          $t('esim_recommend') }}</p>
      <p class="m-0" v-else>{{ $t('similar_available_phone_number') }}</p> -->

      <p class="m-0 cs-title">{{ $t(txtIsdn) }}</p>

      <p class="m-0 font-size-12" v-if="isShowIsdnRecommend">
        {{ $t("esim_total") }}:
        {{ Array.isArray(esimIsdns) ? esimIsdns.length : 0 }}
      </p>
      <p class="m-0" v-else>
        {{ $t("esim_total") }}:
        {{ Array.isArray(resSearchEsimIsdn) ? resSearchEsimIsdn.length : 0 }}
      </p>
    </div>
  </div>
  <div class="mb-3 font-size-12">
    <div
      v-if="loadingEsim || loadingSearchIsdn"
      class="d-flex justify-content-center align-items-center p-5"
    >
      <van-loading color="#C41627" />
    </div>
    <div v-else>
      <!-- Start list eSim -->
      <div v-if="isShowIsdnRecommend">
        <CardIsdn
          @item-isdn="handleSelectIsdn"
          :esimIsdns="recommendedIsdns"
          :activeIsdn="orderDetail.esimIsdn"
        />
      </div>
      <div v-else>
        <CardIsdn
          @item-isdn="handleSelectIsdn"
          :esimIsdns="displayIsdn"
          :activeIsdn="orderDetail.esimIsdn"
        />
      </div>
      <!-- End list eSim -->
      <div v-if="isShowNotFound">
        <div
          class="p-3 pb-5 d-flex justify-content-center align-items-center flex-column"
        >
          <img
            src="@/static/eSim/icon-search-esim.png"
            height="50"
            alt="icon search"
            class="mb-3"
          />
          <p class="text-center font-size-12">{{ $t(notFoundText) }}</p>
        </div>
      </div>
      <div v-if="!isShowNotFound">
        <div
          v-if="
            (isShowIsdnRecommend && esimIsdns && esimIsdns.length > 6) ||
            (!isShowIsdnRecommend &&
              resSearchEsimIsdn &&
              resSearchEsimIsdn.length > 30)
          "
        >
          <div class="d-flex justify-content-center">
            <van-button
              type="default"
              class="bg-transparent border-0 text-primary"
              @click="isViewAll = !isViewAll"
            >
              {{ isViewAll ? $t("esim_view_less") : $t("esim_view_more") }}
              <van-icon :name="isViewAll ? 'arrow-up' : 'arrow-down'" />
            </van-button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End Isdn -->

  <!-- Start Package -->
  <div class="mb-3">
    <div class="mb-2">
      <p class="cs-title">{{ $t("esim_packages") }}</p>
      <p class="cs-des">{{ $t("esim_dataosja_package_instruction") }}</p>
    </div>
    <div class="package-swipe">
      <div
        v-if="loadingPackageEsim"
        class="d-flex justify-content-center align-items-center p-5"
      >
        <van-loading color="#C41627" />
      </div>
      <div v-else>
        <van-swipe
          ref="packageSwipe"
          :loop="false"
          class="my-swipe"
          indicator-color="white"
        >
          <van-swipe-item
            v-for="(group, index) in groupedPackages"
            :key="index"
          >
            <div class="swipe-group">
              <div
                v-for="item in group"
                :key="item.packageCode || item.code"
                class="swipe-item"
                @click="handleSelectPackage(item)"
                :class="{ active: orderDetail.esimPackageCode === (item.packageCode || item.code) }"
              >
                <img
                  src="@/static/eSim/svg/circle-check-solid.svg"
                  alt="icon check"
                  class="cs-icon-check"
                />
                <van-image :src="item.imageUrl || item.iconUrl" class="rounded-3 img-package" />
              </div>
            </div>
          </van-swipe-item>
        </van-swipe>

        <!-- Prev Button -->
        <button class="nav-button left" @click="prevPackage">
          <van-icon name="arrow-left" size="24" />
        </button>

        <!-- Next Button -->
        <button class="nav-button right" @click="nextPackage">
          <van-icon name="arrow" size="24" />
        </button>
      </div>
    </div>
  </div>
  <!-- End Package -->

  <!-- Start button Next -->
  <van-submit-bar
    class="cs-submit-bar cs-submit-bar-nospace"
    :disabled="isDisable"
    :label="$t('esim_total_price')"
    :button-text="$t('esim_next')"
    @submit="handleCheckDailyPurchaseLimit"
    button-color="#C41627"
  >
    <div class="d-flex justify-content-start align-items-baseline gap-2">
      <p class="m-0">{{ $t("esim_total_price") }}</p>
      <p class="m-0 text-dark font-size-18 font-bold">${{ totalPrice }}</p>
    </div>
  </van-submit-bar>
  <!-- End button Next-->
</template>
<script>
import { Card } from "vant";
import { Image as VanImage } from "vant";
import { Switch } from "vant";
import { Col, Row, Slider, Icon, Empty } from "vant";
import { Grid, GridItem } from "vant";
import { SubmitBar } from "vant";
import { Swipe, SwipeItem } from "vant";
import CardIsdn from "./card/card-isdn.vue";
import getErrorMessage from "@/helpers/error-server";
import { ESIM_ORDER_FLOW } from "@/helpers/esimFlow";
import { mapState } from "vuex";
import { max } from "lodash";
import { Loading } from "vant";

export default {
  props: {
    esimIsdns: {
      type: Array,
      required: true,
    },
    packageEsimABA: {
      type: Array,
      required: true,
    },
    loadingEsim: {
      type: Boolean,
      default: false,
    },
    loadingPackageEsim: {
      type: Boolean,
      default: false,
    },
    // When false, hide the "eSIM supported devices" link at the top
    // (used by the buy-new-metfone-esim page UI).
    showSupportedDevices: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    [Card.name]: Card,
    [Image.name]: Image,
    [VanImage.name]: VanImage,
    [Switch.name]: Switch,
    [Col.name]: Col,
    [Row.name]: Row,
    [Slider.name]: Slider,
    [Icon.name]: Icon,
    [Empty.name]: Empty,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [SubmitBar.name]: SubmitBar,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    CardIsdn,
    [Loading.name]: Loading,
  },
  data() {
    return {
      checked: true,
      minRange: 1,
      maxRange: 1000,
      priceRange: [this.minRange, this.maxRange],
      search: "",
      selectedPackageCode: "",
      isViewAll: false,
      resSearchEsimIsdn: [],
      orderDetail: {
        esimIsdn: "",
        esimPriceIsdn: 0,
        esimPackageCode: "",
        esimPricePackage: 0,
        esimPackageName: "",
        totalPrice: 0,
      },
      loadingSearchIsdn: false,
      isShowIsdnRecommend: true,
      txtIsdn: "esim_recommend",
      minGap: 100,
    };
  },
  computed: {
    ...mapState("userStore", ["profile", "defaultParam"]),
    recommendedIsdns() {
      if (!Array.isArray(this.esimIsdns)) return [];
      const grouped = [1, 2, 3].map((groupNo) => {
        return this.esimIsdns
          .filter((item) => {
            const groupValue = item.groupNo ?? item.group_no;
            return String(groupValue) === String(groupNo);
          })
          .sort((a, b) => a.price - b.price)
          .slice(0, 5); // Lấy tối đa 5 số trong mỗi nhóm
      });
      const combined = grouped.flat();
      const result = combined.length > 0 ? combined : this.esimIsdns;
      return this.isViewAll ? this.esimIsdns : result.slice(0, 6);
    },
    totalPrice() {
      const { esimPriceIsdn, esimPricePackage } = this.orderDetail;
      return (esimPriceIsdn || 0) + (esimPricePackage || 0);
    },
    isDisable() {
      return !this.orderDetail.esimIsdn;
    },
    isShowNotFound() {
      const isEsimIsdnsEmpty =
        !Array.isArray(this.esimIsdns) || this.esimIsdns.length === 0;
      const isSearchResultEmpty =
        !Array.isArray(this.resSearchEsimIsdn) ||
        this.resSearchEsimIsdn.length === 0;
      if (
        (isEsimIsdnsEmpty && this.isShowIsdnRecommend) ||
        (isSearchResultEmpty && !this.isShowIsdnRecommend)
      ) {
        return true;
      }
      return false;
    },
    notFoundText() {
      const isEsimIsdnsEmpty =
        !Array.isArray(this.esimIsdns) || this.esimIsdns.length === 0;
      const isSearchResultEmpty =
        !Array.isArray(this.resSearchEsimIsdn) ||
        this.resSearchEsimIsdn.length === 0;

      if (isEsimIsdnsEmpty && this.isShowIsdnRecommend) {
        return "esim_search_hint";
      } else if (isSearchResultEmpty && !this.isShowIsdnRecommend) {
        return "esim_similar_not_found";
      }
      return "esim_search_hint";
    },
    displayIsdn() {
      return this.isViewAll
        ? this.resSearchEsimIsdn
        : this.resSearchEsimIsdn.slice(0, 30);
    },
    groupedPackages() {
      const result = [];
      if (this.packageEsimABA) {
        for (let i = 0; i < this.packageEsimABA.length; i += 2) {
          result.push(this.packageEsimABA.slice(i, i + 2));
        }
      }
      return result;
    },
  },
  created() {},
  watch: {
    // search(val) {
    //   this.handleSearch(val);
    // },
    priceRange(val) {
      this.onSliderInput(val);
    },
    search(newVal, oldVal) {
      // Nếu có ký tự không phải số, thông báo và loại bỏ
      if (newVal && !/^\+?\d*$/.test(newVal)) {
        this.$notify({
          code: 1,
          message: this.$t("available_only_number"),
        });
        this.search = newVal.replace(/[^\d+]/g, "").replace(/(?!^)\+/g, ""); // chỉ giữ "+" đầu tiên nếu có
      }
    },
  },
  methods: {
    onSliderInput(val) {
      const [min, max] = val;
      if (max - min < this.minGap) {
        // Nếu kéo trái thì giữ max, đẩy min về max - minGap
        if (this.priceRange[0] !== min) {
          this.priceRange = [max - this.minGap, max];
        }
        // Nếu kéo phải thì giữ min, đẩy max về min + minGap
        else {
          if (min + this.minGap < 1000) {
            this.priceRange = [min, min + this.minGap];
          } else {
            this.priceRange = [1000 - this.minGap, 1000];
          }
        }
      } else {
        this.priceRange = val;
      }
    },
    stateAsObject(value) {
      return JSON.parse(JSON.stringify(value));
    },
    handleSearch() {
      if (this.defaultParam) {
        this.loadingSearchIsdn = true; // Bật loading
        this.txtIsdn = "similar_available_phone_number";
        const defaultParam = this.stateAsObject(this.defaultParam);

        let prefixSearch = "";
        if (this.search) {
          if (this.search.startsWith("0")) {
            prefixSearch = this.search.slice(1); // Bỏ số 0 đầu tiên
          } else if (this.search.startsWith("+855")) {
            prefixSearch = this.search.slice(4); // Bỏ mã quốc gia 855
          } else {
            prefixSearch = this.search;
          }
        }

        let params = defaultParam;
        params.msisdn = prefixSearch;
        params.isdn = prefixSearch;
        params.priceFrom = this.priceRange[0];
        params.priceTo = this.priceRange[1];
        params.pageNo = 1;
        params.pageSize = 100;

        this.$store
          .dispatch("esimMetfoneStore/searchIsdn", params)
          .then((res) => {
            if (res) {
              let result = res.data;
              if (result && result.errorCode == 0) {
                if (result.lookupIsdnMobiles) {
                  this.isShowIsdnRecommend = false;
                  this.resSearchEsimIsdn = Array.isArray(result.lookupIsdnMobiles)
                    ? result.lookupIsdnMobiles
                    : [result.lookupIsdnMobiles];

                  let isdnExists = false;
                  if (this.resSearchEsimIsdn) {
                    isdnExists = this.resSearchEsimIsdn.some(
                      (item) => item.isdn === this.orderDetail.esimIsdn
                    );
                  } else {
                    this.orderDetail.esimIsdn = "";
                    this.orderDetail.esimPriceIsdn = 0;
                  }
                  if (!isdnExists) {
                    this.orderDetail.esimIsdn = "";
                    this.orderDetail.esimPriceIsdn = 0;
                  }
                }
              } else {
                this.$notify({
                  code: result.errorCode,
                  message: result.message,
                });
              }
            }
            this.loadingSearchIsdn = false; // Tắt loading khi xong
          })
          .catch(() => {
            this.loadingSearchIsdn = false; // Tắt loading nếu lỗi
          });
      }
    },
    handleMyOrder() {
      this.$store.dispatch("routerStore/setIsBackToHomeFromOrder", false);
      this.$router.push("/my-order");
    },
    handleSelectIsdn(item) {
      if (this.orderDetail.esimIsdn === item.isdn) {
        this.orderDetail.esimIsdn = null;
        this.orderDetail.esimPriceIsdn = 0;
      } else {
        this.orderDetail.esimIsdn = item.isdn;
        this.orderDetail.esimPriceIsdn = item.price;
      }
    },
    handleSelectPackage(item) {
      const packageCode = item.packageCode || item.code;
      const packageName = item.packageName || item.name;
      if (this.orderDetail.esimPackageCode === packageCode) {
        this.orderDetail.esimPackageCode = null;
        this.orderDetail.esimPricePackage = 0;
        this.orderDetail.esimPackageName = null;
      } else {
        this.orderDetail.esimPackageCode = packageCode;
        this.orderDetail.esimPricePackage = item.price;
        this.orderDetail.esimPackageName = packageName;
      }
    },
    handleShowCheckEsim() {
      this.$emit("is-show", true);
    },

    handleCheckDailyPurchaseLimit() {
      this.$store.dispatch("esimBuyStore/detailPaymentInfo", null);
      this.$store.dispatch("routerStore/setIsBackToHomeFromOrder", false);
      if (this.defaultParam) {
        const defaultParam = this.stateAsObject(this.defaultParam);
        let params = defaultParam;
        
        this.$store.dispatch("loadingStore/showLoading", { status: true });
        this.$store
          .dispatch("esimMetfoneStore/checkLimitBuySim", params)
          .then((res) => {
            if (res) {
              let result = res.data;
              if (result && result.errorCode == 0) {
                this.$store.dispatch("esimBuyStore/orderDetail", {
                  esimOrderFlow: ESIM_ORDER_FLOW.BUY,
                  esimIsdn: this.orderDetail.esimIsdn,
                  esimPriceIsdn: this.orderDetail.esimPriceIsdn,
                  esimPackageCode: this.orderDetail.esimPackageCode,
                  esimPricePackage: this.orderDetail.esimPricePackage,
                  esimPackageName: this.orderDetail.esimPackageName,
                  totalPrice:
                    this.orderDetail.esimPriceIsdn +
                    this.orderDetail.esimPricePackage,
                });
                this.$router.push({ path: "/register-infor" });
              } else {
                this.$notify({
                  code: result.errorCode,
                  message: result.message,
                });
              }
            }
          });
        this.$store.dispatch("loadingStore/showLoading", { status: false });
      }
    },

    nextPackage() {
      this.$refs.packageSwipe?.next?.(); // gọi phương thức next của van-swipe
    },
    prevPackage() {
      this.$refs.packageSwipe?.prev?.(); // gọi phương thức prev của van-swipe
    },
  },
};
</script>

<style>
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  line-height: 150px;
  text-align: center;
}

.swipe-item {
  position: relative;
  width: 100%;
  /* height: 100px; */
  border-radius: 8px;
}

/* .swipe-item .van-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  aspect-ratio: 1 / 1;
  overflow: hidden;
  border-radius: 8px !important;
} */

.swipe-item .van-image {
  display: block;
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: 8px !important;
}

.swipe-item .van-image img {
  border-radius: 8px !important;
}

.swipe-group {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  padding: 10px;
}

.swipe-item.active {
  border: 1px solid #d80f2c;
  border-radius: 8px;
}

.swipe-item .cs-icon-check {
  display: none;
}

.swipe-item.active .cs-icon-check {
  display: inline-block;
  position: absolute;
  top: -5px;
  right: -5px;
  width: 12px !important;
  height: 12px !important;
  z-index: 10;
}

.my-swipe .van-swipe__indicators {
  display: none;
}

.swipe-group img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.van-submit-bar .van-submit-bar__bar {
  justify-content: space-between;
}

.nav-button {
  border: none;
}

.package-swipe {
  position: relative;
  padding: 10px;
}

.package-swipe .nav-button {
  position: absolute;
  background: transparent;
  width: 40px;
  height: 40px;
  top: 50%;
  transform: translateY(-50%);
  padding: 0;
}

.package-swipe .nav-button.left {
  left: -15px;
}

.package-swipe .nav-button.right {
  right: -15px;
}

.custom-thumb {
  background: #fff !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 50px !important;
  width: 20px;
  height: 20px;
}

.dragging {
  box-shadow: 0 0 0 4px rgba(0, 0, 0, 0.1);
}

.cs-input {
  height: 36px;
}

.cs-input .van-field__value input::placeholder {
  font-size: 12px;
}

.cs-btn-search {
  height: 36px;
  width: fit-content;
  padding: 0 16px !important;
  border-radius: 10px !important;
  font-size: 12px !important;
}

.cs-title {
  font-size: 14px !important;
  font-weight: bolder;
  margin-bottom: 5px;
}

.cs-des {
  font-size: 12px;
  color: #000;
  margin-bottom: 0 !important;
}

.cs-submit-bar {
  bottom: 64px !important;
}

.cs-submit-bar-nospace {
  bottom: 0 !important;
}
</style>
